<div class="container--padding">
    <div class="row">
        <div class="col-xl-6 col-lg-6">
            <h2 class="mt-5" translate>Facebook events</h2>
        </div>
        <div class="col-xl-6 col-lg-6 text-right">

        </div>
    </div>
    <div *ngIf="experiences && !noRecords" class="row mt-5 ">
        <div class="col-lg-12">
            <table class="table table-white">
                <thead>
                    <tr>
                        <th scope="col" translate>Name</th>
                        <th scope="col" translate>Date</th>
                        <th scope="col" translate>Description</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let experience of experiences; let i=index">
                        <td>{{experience.name}}</td>
                        <td>{{experience.startTime | date: 'dd.MM'}} - {{experience.endTime | date: 'dd.MM'}}</td>
                        <td>{{experience.description}}</td>
                        <td><button (click)="importFbExperience(experience.id)"
                                class="button button--purple button--big listing--button" type="button"
                                [disabled]="loader"><span *ngIf="loader"><span class="spinner-border spinner-border-sm"
                                        role="status" aria-hidden="true"></span>
                                    <span translate>Importing</span></span><span *ngIf="!loader"
                                    translate>Import</span></button></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>


    <div *ngIf="noRecords" class="welcome__screen">
        <div class="welcome__screen__figure col-xl-6 col-lg-6 col-md-6 col-sm-6 mt-5">
        </div>
        <p><span translate>Begin paragraph1</span> <br />
            <span translate>Begin paragraph2</span>
        </p>
        <button (click)="createExperience()" type="button" class="button button--purple button--big"
            [disabled]="loader"><span *ngIf="loader"><span class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
                <span translate>Loading</span></span><span *ngIf="!loader" translate>Begin button</span></button>
    </div>
</div>